export const BASE_URL = process.env.REACT_APP_TMDB_BASE_URL
export const API_KEY = process.env.REACT_APP_TMDB_TOKEN
export const headers = {
  Authorization: "Bearer " + API_KEY,
}
